import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { api } from "../_services/api.service";
import { Row, Col, Card, CardBody, CustomInput, Button } from "reactstrap";
import swal from "sweetalert";
import DropIn from "braintree-web-drop-in-react";
import Loader from "react-loaders";
import AppCache from "../_helpers/appCache";
import { authenticationService } from '../_services/authentication.service';

const BraintreePartner = ({ user, partnerUsersCount, fromRegister, history, partner }) => {
  let [instance, setInstance] = useState(null);
  let [clientToken, setClientToken] = useState("");
  let [braintreePlans, setBraintreePlans] = useState([]);
  let [webAppUrl, setWebAppUrl] = useState("");
  let [selectedPlan, setSelectedPlan] = useState(null);
  let [userHasActivePlan, setUserHasActivePlan] = useState(false);
  let [activeSubscription, setActiveSubscription] = useState(null);
  let [braintreeError, setBraintreeError] = useState(false);
  let [combinedSubscriptionMessage, setCombinedSubscriptionMessage] = useState(
    ""
  );

  let [shouldPickPlan, setShouldPickPlan] = useState(true);
  let [usersAccess, setUsersAccess] = useState(1); // default Full Access
  let [numberOfUsers, setNumberOfUsers] = useState(0);
  let [numberOfUsersError, setNumberOfUsersError] = useState(false);

  let [isLoadingPlans, setIsLoadingPlans] = useState(false);
  let [isBuying, setIsBuying] = useState(false);
  let [isCancelling, setIsCancelling] = useState(false);
  let [isLoadingSubscription, setIsLoadingSubscription] = useState(false);

  useEffect(() => {
    if (user && user.userID > 0) {
      setCombinedSubscriptionMessage(user.combinedSubscriptionMessage);

      api.getWebAppUrl().then((url) => {
        setWebAppUrl(url);
      });

      api.getBraintreeClientToken(user.userID).then(
        (ct) => {
          setClientToken(ct);
        },
        (err) => {
          setBraintreeError(true);
        }
      );

      loadSubscription(user.userID);
    }
  }, [user, fromRegister]);

  const loadPlans = () => {
    if (numberOfUsers > 0) {
      setShouldPickPlan(true);
      setIsLoadingPlans(true);
      setNumberOfUsersError(false);
      api
        .getBraintreePlansForPartner(
          numberOfUsers,
          usersAccess == 0 ? true : false
        )
        .then(
          (plansResp) => {
            let planList = [];
            plansResp.forEach((el) => {
              const exists = planList.find((x) =>
                x.some((v) => v.maxUsers == el.maxUsers)
              );
              if (exists) {
                exists.push(el);
              } else {
                planList.push([el]);
              }
            });
            planList = planList.sort((a, b) => {
              return a[0].maxUsers - b[0].maxUsers;
            });

            setIsLoadingPlans(false);
            setBraintreePlans(planList);
          },
          (err) => {
            setBraintreeError(true);
            setIsLoadingPlans(false);
          }
        );
    } else {
      setNumberOfUsersError(true);
    }
  };

  const loadSubscription = (userId) => {
    setIsLoadingSubscription(true);
    api.getBraintreeActiveSubscriptions(userId).then(
      (data) => {
        setIsLoadingSubscription(false);
        if (data && data.subscription) {
          setActiveSubscription(data.subscription);
          setSelectedPlan(data.plan);
          setShouldPickPlan(false);
          setUserHasActivePlan(true);
        }
      },
      (err) => {
        setIsLoadingSubscription(false);
        setBraintreeError(true);
      }
    );
  };

  const buy = async () => {
    try {
      if (selectedPlan != null) {
        setIsBuying(true);
        let result = await instance.requestPaymentMethod();
        let nonce = result.nonce;
        api
          .createBraintreeTransaction(
            user.email,
            nonce,
            selectedPlan.price,
            selectedPlan.id
          )
          .then(
            (data) => {
              setIsBuying(false);
              loadSubscription(user.userID);
              updateSubscriptionMessage();
              showSuccessPopup();
            },
            (err) => {
              setBraintreeError(true);
              setIsBuying(false);
            }
          );
      } else {
        swal("Please select a plan first", {
          buttons: {
            ok: {
              text: "Ok",
              value: "ok",
              className: "btn-success",
            },
          },
          icon: "warning",
        });
      }
    } catch (err) {
      setBraintreeError(true);
      setIsBuying(false);
      console.log(err);
    }
  };

  const showSuccessPopup = () => {
    swal({
      title: "Thank you for subscribing to Definitive Choice!",
      icon: "success",
      buttons: {
        manageUsers: { text: "Manage Users", className: "btn-primary" },
        manageTemplates: { text: "Manage Templates", className: "btn-primary" },
      },
      closeOnClickOutside: !fromRegister,
      closeOnEsc: !fromRegister,
    }).then(val => {
      if (!history)
        return;

      if (fromRegister) {
        authenticationService.login(user.email, user.password)
          .then(s => {
            AppCache.setPartner(partner.partnerID, partner.partnerName);

            if (val === "manageUsers") history.push({ pathname: `/users/${partner.partnerID}` });
            if (val === "manageTemplates") history.push({ pathname: `/decisiontemplates/${partner.partnerID}` });
          });
      } else {
        let p = AppCache.getPartner();
        if (!p)
          return;

        if (val === "manageUsers") history.push({ pathname: `/users/${p.partnerId}` });
        if (val === "manageTemplates") history.push({ pathname: `/decisiontemplates/${p.partnerId}` });
      }
    });
  }

  const cancel = () => {
    swal({
      text:
        "Please confirm that you wish to cancel your organization’s subscription to Definitive Choice.  Information specific to your users will remain in their accounts if they want to start a personal subscription.",
      icon: "warning",
      buttons: {
        ok: "Cancel Subscription",
        cancel: "Close",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        setIsCancelling(true);
        api.cancelSubscription(user.userID, activeSubscription.id).then(
          (data) => {
            setIsCancelling(false);

            window.location.reload(true);
          },
          (err) => {
            setIsCancelling(false);

            setBraintreeError(true);
          }
        );
      }
    });
  };

  const updateSubscriptionMessage = () => {
    api.getUserById(user.userID).then((u) => {
      setCombinedSubscriptionMessage(u.combinedSubscriptionMessage);
    });
  };

  const onDropinInstance = (inst) => {
    setInstance(inst);
  };

  const goToWebApp = () => {
    if (webAppUrl !== "") {
      window.location.href = webAppUrl;
    }
  };

  const goToLoginPage = () => {
    if (history) {
      history.push({
        pathname: '/login'
      });
    }
  }

  const getGroupTitle = (index) => {
    if (braintreePlans.length == 3) {
      if (index == 0) {
        return (
          <p style={{ textAlign: "center", color: "red" }}>
            Our next lowest plan
          </p>
        );
      }
      if (index == 1) {
        return (
          <p style={{ textAlign: "center", color: "green" }}>
            Our recommendation
          </p>
        );
      }
      if (index == 2) {
        return (
          <p style={{ textAlign: "center", color: "blue" }}>
            Our next highest plan
          </p>
        );
      }
    }

    if (braintreePlans.length == 2) {
      if (index == 0) {
        return (
          <p style={{ textAlign: "center", color: "green" }}>
            Our recommendation
          </p>
        );
      }
      if (index == 1) {
        return (
          <p style={{ textAlign: "center", color: "blue" }}>
            Our next highest plan
          </p>
        );
      }
    }
  };

  return (
    <Fragment>
      {user && !braintreeError && (
        <Card className="main-card mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <div className="card-title">Subscription Information</div>
                <div style={{ margin: "30px" }}>
                  {combinedSubscriptionMessage}
                </div>
                {clientToken == "" && <p>Loading...</p>}
                {clientToken != "" && (
                  <div>
                    {isLoadingSubscription && <p>Loading subscription...</p>}
                    {!isLoadingSubscription && activeSubscription !== null && (
                      <div>
                        <h5>The following subscription is active for you:</h5>
                        <p>
                          <b>Start date: </b>
                          {new Date(
                            activeSubscription.firstBillingDate
                          ).toDateString()}
                        </p>
                        <p>
                          <b>Next billing date: </b>
                          {new Date(
                            activeSubscription.nextBillingDate
                          ).toDateString()}
                        </p>
                        {selectedPlan !== null && (
                          <p>
                            <b>Plan description: </b>
                            {selectedPlan.type}
                          </p>
                        )}
                        {/* <p><b>Expires: </b>{!activeSubscription.neverExpires ? 'True' : 'False'}</p> */}
                      </div>
                    )}

                    {(!userHasActivePlan || shouldPickPlan) && (
                      <Row>
                        <Col md="12">
                          <h4>Let us select the plan that is best for you!</h4>
                          <div>
                            <span>
                              How many users will need access to Definitive
                              Choice?{" "}
                            </span>
                            <Row style={{paddingLeft: "15px", paddingTop: "10px"}}>
                              <CustomInput
                                type="number"
                                className="form-control"
                                style={{ width: "50%" }}
                                value={numberOfUsers}
                                onChange={(e) => setNumberOfUsers(e.target.value)}
                              />
                              <Button
                                color="primary"
                                style={{
                                  marginLeft: "15px",
                                }}
                                onClick={() => loadPlans()}
                              >
                                Check plans
                              </Button>
                            </Row>
                            {numberOfUsersError && (
                              <div
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >
                                Please provide a number of users
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    )}

                    {isLoadingPlans && <p>Loading plans...</p>}
                    {!isLoadingPlans &&
                      braintreePlans.length > 0 &&
                      shouldPickPlan && (
                        <Row
                          style={{ marginTop: "20px", marginBottom: "10px" }}
                        >
                          {braintreePlans.map((group, groupIndex) => {
                            return (
                              <Col md="4">
                                <div
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "5px",
                                  }}
                                >
                                  {getGroupTitle(groupIndex)}
                                  <p style={{ textAlign: "center", fontWeight: "bold" }}>
                                    {group[0].type.split("-")[0]}
                                  </p>
                                  {group
                                    .sort((a, b) => a.price - b.price)
                                    .map((p) => {
                                      return (
                                        <div
                                          style={{
                                            textAlign: "center",
                                            border:
                                              selectedPlan &&
                                              selectedPlan.id === p.id
                                                ? "3px solid green"
                                                : "1px solid lightgray",
                                            padding: "5px",
                                            margin: "5px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            if (
                                              partnerUsersCount &&
                                              partnerUsersCount < p.maxUsers
                                            ) {
                                              swal(
                                                `You cannot select that subscription plan, since you currently have ${partnerUsersCount} active users.`,
                                                { icon: "warning" }
                                              );
                                            } else {
                                              setSelectedPlan(p);
                                            }
                                          }}
                                        >
                                          {/* <h4>{p.type}</h4> */}
                                          <span>{p.description}</span>
                                          <h5>${p.price}</h5>
                                        </div>
                                      );
                                    })}
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      )}
                    {((!userHasActivePlan && selectedPlan !== null) ||
                      (shouldPickPlan && selectedPlan !== null)) && (
                      <>
                        <DropIn
                          options={{
                            authorization: clientToken,
                          }}
                          onInstance={onDropinInstance}
                        />
                        <Button
                          color="primary"
                          onClick={buy}
                          disabled={isBuying}
                        >
                          Buy
                        </Button>
                      </>
                    )}
                    <Row style={{ marginTop: "20px" }}>
                      <Col md="12">
                        {activeSubscription !== null && (
                          <Button
                            color="danger"
                            style={{
                              margin: "5px"
                            }}
                            onClick={cancel}
                            disabled={isCancelling}
                          >
                            Cancel Subscription
                          </Button>
                        )}
                        {activeSubscription !== null && !shouldPickPlan && (
                          <Button
                            color="secondary"
                            style={{
                              margin: "5px"
                            }}
                            onClick={() => {
                              setShouldPickPlan(true);
                              setSelectedPlan(null);
                              setBraintreePlans([]);
                            }}
                          >
                            Update Plan
                          </Button>
                        )}
                        {activeSubscription !== null && (
                          <Button
                            color="primary"
                            style={{
                              margin: "5px"
                            }}
                            onClick={fromRegister ? goToLoginPage : goToWebApp}
                          >
                            {fromRegister ? "Go the Management Portal" : "Make Decisions!"}
                          </Button>
                        )}
                        {(isBuying || isCancelling) && (
                          <Loader
                            style={{ display: "inline-block" }}
                            type="ball-pulse"
                            active
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      {braintreeError && (
        <Card className="main-card mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <div className="card-title">
                  Something went wrong and we couldn't load the subscription
                  information at this moment.
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </Fragment>
  );
};

export default BraintreePartner;
